import { Action, ThunkAction, configureStore } from '@reduxjs/toolkit';
import viewsReducer from '../pages/redux';
import appReducer from 'pages/app/redux';
import homepageReducer from 'pages/SignIn/redux';
import logsReducer from 'pages/Logs/redux';
import metricsReducer from 'pages/Metrics/redux';
import reportingReducer from 'pages/Reporting/redux';
import complianceReducer from 'pages/Compliance/redux';
import recordsReducer from 'pages/Records/redux';
import settingsReducer from 'pages/Settings/redux';
import globalReducer, { callEndpoint } from './global';

export const store = configureStore({
  reducer: {
    homepage: homepageReducer,
    views: viewsReducer,
    global: globalReducer,
    app: appReducer,
    logs: logsReducer,
    metrics: metricsReducer,
    reporting: reportingReducer,
    compliance: complianceReducer,
    records: recordsReducer,
    settings: settingsReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    thunk: {
      extraArgument: { callEndpoint },
    },
    serializableCheck: false,
  }),
});

export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
